exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".App-container{text-align:center;width:320px;margin:auto;border-bottom:5px solid grey}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/App/App.scss
// module id = 326
// module chunks = 0